import {createSlice} from '@reduxjs/toolkit';

import storeSliceNames from '../../consts/storeSliceNames';

const initialCredentials = {ssid: '', password: '', type: ''};

const initialState = {
    apiVersion: null,
    deviceCertificate: null,
    currentNetwork: {
        isHidden: undefined,
        credentials: initialCredentials,
    },
    storedNetworks: [],
    scannedNetworks: [],
    validationErrors: [],
    removedNetworks: [],
};

const networksSlice = createSlice({
    name: storeSliceNames.networks,
    initialState,
    reducers: {
        setApiVersion(state, action) {
            state.apiVersion = action.payload;
        },
        setDeviceCertificate(state, action) {
            state.deviceCertificate = action.payload;
        },
        setDusn(state, action) {
            state.dusn = action.payload;
        },
        setScannedNetworks(state, action) {
            state.scannedNetworks = action.payload;
        },
        clearScannedNetworks(state) {
            state.scannedNetworks = [];
        },
        setStoredNetworks(state, action) {
            state.storedNetworks = action.payload;
        },
        clearStoredNetworks(state) {
            state.storedNetworks = [];
        },
        setIsCurrentNetworkHidden(state, action) {
            state.currentNetwork.isHidden = action.payload;
        },
        setCurrentNetworkCredentials(state, action) {
            state.currentNetwork.credentials = action.payload;
        },
        updateCurrentNetworkCredentials(state, action) {
            state.currentNetwork.credentials = {
                ...state.currentNetwork.credentials,
                ...action.payload,
            };
        },
        clearCurrentNetworkCredentials(state) {
            state.currentNetwork.credentials = initialCredentials;
        },
        setValidationError(state, action) {
            state.validationErrors.push(action.payload);
        },
        removeValidationError(state, action) {
            state.validationErrors = state.validationErrors.filter((x) => x !== action.payload);
        },
        clearValidationErrors(state) {
            state.validationErrors = [];
        },
        setRemovedNetwork(state, action) {
            const {ssid, timeoutId} = action.payload;

            state.removedNetworks.push({ssid, timeoutId});
        },
        updateRemovedNetwork(state, action) {
            const {ssid, ...rest} = action.payload;
            const network = state.removedNetworks.find((n) => n.ssid === ssid);

            if (network) {
                Object.assign(network, rest);
            }
        },
        clearRemovedNetwork(state, action) {
            const ssid = action.payload;
            const network = state.removedNetworks.find((n) => n.ssid === ssid);

            clearTimeout(network.timeoutId);

            state.removedNetworks = state.removedNetworks.filter((n) => n.ssid !== ssid);
        },
        clearRemovedNetworks(state) {
            state.removedNetworks = state.removedNetworks.filter((n) => !n?.isCompleted);
        },

        clearNetworksState() {
            return initialState;
        },
    },
});

export const setApiVersion = (apiVersion) => networksSlice.actions.setApiVersion(apiVersion);
export const setDeviceCertificate = (deviceCertificate) =>
    networksSlice.actions.setDeviceCertificate(deviceCertificate);
export const setNetworkConnectionStatus = (statusData) => networksSlice.actions.setNetworkConnectionStatus(statusData);
export const setIsCurrentNetworkHidden = (isHidden) => networksSlice.actions.setIsCurrentNetworkHidden(isHidden);
export const setCurrentNetworkCredentials = (credentials) =>
    networksSlice.actions.setCurrentNetworkCredentials(credentials);
export const updateCurrentNetworkCredentials = (credentials) =>
    networksSlice.actions.updateCurrentNetworkCredentials(credentials);
export const clearCurrentNetworkCredentials = () => networksSlice.actions.clearCurrentNetworkCredentials();
export const setStoredNetworks = (networksList) => networksSlice.actions.setStoredNetworks(networksList);
export const clearStoredNetworks = () => networksSlice.actions.clearStoredNetworks();
export const setScannedNetworks = (networksList) => networksSlice.actions.setScannedNetworks(networksList);
export const clearScannedNetworks = () => networksSlice.actions.clearScannedNetworks();
export const setValidationError = (errorType) => networksSlice.actions.setValidationError(errorType);
export const removeValidationError = (errorType) => networksSlice.actions.removeValidationError(errorType);
export const clearValidationErrors = () => networksSlice.actions.clearValidationErrors();
export const setRemovedNetwork = (data) => networksSlice.actions.setRemovedNetwork(data);
export const updateRemovedNetwork = (data) => networksSlice.actions.updateRemovedNetwork(data);
export const clearRemovedNetwork = (ssid) => networksSlice.actions.clearRemovedNetwork(ssid);
export const clearRemovedNetworks = () => networksSlice.actions.clearRemovedNetworks();
export const clearNetworksState = () => networksSlice.actions.clearNetworksState();

export default networksSlice.reducer;
